// extracted by mini-css-extract-plugin
export default {"componentWrapper":"Loader_componentWrapper__WUUG6","spinner":"Loader_spinner__3V9+e"};